import {Button, Col, Modal, Row} from "react-bootstrap";
import React, {useState} from "react";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import {RiShutDownLine} from "react-icons/ri";
import {VscDebugRestart, VscRemoteExplorer} from "react-icons/vsc";
import {MdOutlineLock} from "react-icons/md";
import {setSelectedPrimerPos} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import moment from "moment";
import useMediaQuery from "../../../../../hooks/useMediaQuery";
import {SiVodafone} from "react-icons/si";
import PrimerPosSimInfoModal from "./primer-pos-sim-info-modal";

const PrimerPosSunmiInfoModal = ({sunmiDeviceInfo, setSunmiDeviceInfo, onlineStatus}) => {
    const isMobileScreen = useMediaQuery("(max-width: 768px)");
    const dispatch = useDispatch();
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const [sunmiLoader, setSunmiLoader] = useState(false);
    const [simInfo, setSimInfo] = useState(null);
    const [simInfoLoader, setSimInfoLoader] = useState(false);


    const sunmiDeviceAction = (action) => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            let requestData = {
                _id: selectedPos?._id,
                action: action
            }
            if(action === "lock" && (isEmpty(selectedPos?.orderId) || isEmpty(selectedPos?.serialNumber))) {
                return toast.error("Μπορείτε να κλειδώσετε το τερματικό μόνο εαν έχει δεσμευμένη συνδρομή!");
            } else if(action === "lock") {
                const lockPassword = `P${selectedPos.orderId}_${selectedPos?.serialNumber}`;
                requestData.lockPassword = lockPassword.length > 16 ? lockPassword.slice(0, 16) : lockPassword;
            }
            if(action === "remoteControl" && !sunmiDeviceInfo?.net?.wifi) {
                return toast.error("Η λειτουργία απομακρυσμένου ελέγχου είναι διαθέσιμη μόνο σε συσκευές με Wi-Fi");
            }
            setSunmiLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-sunmi-api", requestData, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSunmiLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        if(action === "remoteControl") {
                            window.open(res.data.data, "_blank");
                        }
                        if(res.data?.object) dispatch(setSelectedPrimerPos(res.data.object));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSunmiLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const getSunmiDeviceInfo = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            setSunmiLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-sunmi-api", {_id: selectedPos?._id, action: "getDeviceInfo", isOnline: onlineStatus}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSunmiLoader(false);
                    if(res.data.status === "200") {
                        setSunmiDeviceInfo(res.data?.data);
                        if(!isEmpty(res.data?.object)) {
                            dispatch(setSelectedPrimerPos(res.data.object));
                        }
                        toast.success(res.data.message);
                    } else {
                        setSunmiDeviceInfo(null);
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSunmiDeviceInfo(null);
                setSunmiLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const getSimInfo = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber && !isEmpty(sunmiDeviceInfo?.net?.sim)) {
            const requestData = {_id: selectedPos?._id, action: "info", sim: sunmiDeviceInfo?.net?.sim}
            setSimInfoLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-vodafone-api", requestData, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSimInfoLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        if(res.data?.data) setSimInfo(res.data.data);
                        if(res.data?.object) dispatch(setSelectedPrimerPos(res.data.object));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSimInfoLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }


    return (
        <React.Fragment>
            <Modal backdrop={"static"} className="themeModalMedium" show={!isEmpty(sunmiDeviceInfo)} onHide={() => setSunmiDeviceInfo(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>Διαχείριση Συσκευής POS</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{maxHeight: isMobileScreen ? "60vh" : "70vh", overflowY: 'auto', overflowX: isMobileScreen? 'auto' : 'hidden'}}>
                        <Row>
                            <Col md={3}>
                                <p className="text-muted mb-2"><i>Πληροφορίες Συσκευής:</i></p>
                            </Col>
                            <Col md={9}>
                                <Button
                                    disabled={sunmiLoader}
                                    className="mb-2 float-right"
                                    size="sm"
                                    onClick={() => getSunmiDeviceInfo()}>
                                    Ενημέρωση Δεδομένων
                                    {!sunmiLoader && (<i className="fa-solid fa-rotate ml-1" style={{fontSize: "12px"}}></i>)}
                                    {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                </Button>
                            </Col>
                        </Row>
                        <div className={"d-flex justify-content-between"}>
                            <table style={{width: "inherit", flex: 1}} className={"simpleClassicTable mr-2"}>
                                <thead>
                                <tr>
                                    <th colSpan={2}>Γενικές Πληροφορίες</th>
                                </tr>
                                </thead>
                                <colgroup>
                                    <col span={1} style={{width: "50%"}}></col>
                                    <col span={1} style={{width: "50%"}}></col>
                                </colgroup>
                                <tbody>
                                <tr><td>Serial Number</td><td>{sunmiDeviceInfo?.base?.msn}</td></tr>
                                <tr><td>Κωδικός Διαχειριστή</td><td>{sunmiDeviceInfo?.base?.msn.slice(-6)}*!#@%</td></tr>
                                <tr><td>IMEI</td><td>{sunmiDeviceInfo?.base?.imei}</td></tr>
                                <tr><td>Μοντέλο</td><td>{sunmiDeviceInfo?.base?.model}</td></tr>
                                <tr><td>Τοποθεσία</td><td>{sunmiDeviceInfo?.base?.location}</td></tr>
                                <tr><td>Android (ROM) Version</td><td>{`${sunmiDeviceInfo?.base?.sysversion} (${sunmiDeviceInfo?.base?.romversion})`}</td></tr>
                                <tr><td>Ανάλυση Οθόνης</td><td>{sunmiDeviceInfo?.device?.resolution}</td></tr>
                                <tr><td>Ποσοστό Μπαταρίας</td><td>{sunmiDeviceInfo?.running?.bpercent}</td></tr>
                                <tr><td>Φορτίζει</td><td>{sunmiDeviceInfo?.running?.charging ? "ΝΑΙ" : "ΟΧΙ"}</td></tr>
                                <tr><td>CPU Usage</td><td>{`${sunmiDeviceInfo?.running?.cpu} (Χρήση: ${sunmiDeviceInfo?.running?.cpercent})`}</td></tr>
                                <tr><td>RAM Usage</td><td>{`${sunmiDeviceInfo?.storage?.mem_used} / ${sunmiDeviceInfo?.storage?.mem_total} (${sunmiDeviceInfo?.running?.mpercent})`}</td></tr>
                                <tr><td>Disk Usage</td><td>{`${sunmiDeviceInfo?.storage?.sd_used} / ${sunmiDeviceInfo?.storage?.sd_total} (${(Number(sunmiDeviceInfo?.storage?.sd_used?.replace(" GB", "") || 0) / Number(sunmiDeviceInfo?.storage?.sd_total?.replace(" GB", "") || 1) * 100).toFixed(0)} %)`}</td></tr>
                                <tr><td>Θερμοκρασία</td><td>{sunmiDeviceInfo?.running?.temper}</td></tr>

                                </tbody>
                            </table>
                            <div style={{flex: 1}} className={"d-flex flex-column"}>
                                <table className={"simpleClassicTable mb-2"}>
                                    <thead>
                                    <tr>
                                        <th colSpan={2}>Πληροφορίες Δικτύου</th>
                                    </tr>
                                    </thead>
                                    <colgroup>
                                        <col span={1} style={{width: "50%"}}></col>
                                        <col span={1} style={{width: "50%"}}></col>
                                    </colgroup>
                                    <tbody>
                                    <tr><td>Τύπος Σύνδεσης</td><td>{sunmiDeviceInfo?.net?.wifi ? "WiFi" : "Mobile Data"}</td></tr>
                                    <tr><td>WiFi Network</td><td>{`${sunmiDeviceInfo?.net?.wifi_name} (Σήμα: ${sunmiDeviceInfo?.net?.wifi_rssi}dBm)`}</td></tr>
                                    <tr><td>IP Address</td><td>{sunmiDeviceInfo?.net?.ip}</td></tr>
                                    <tr><td>Sim SN</td><td>{sunmiDeviceInfo?.net?.sim}</td></tr>
                                    <tr><td>Sim Operator</td><td>{sunmiDeviceInfo?.net?.operator}</td></tr>
                                    </tbody>
                                </table>
                                <table className={"simpleClassicTable"}>
                                    <thead>
                                    <tr>
                                        <th colSpan={2}>Πληροφορίες Εκτυπωτή</th>
                                    </tr>
                                    </thead>
                                    <colgroup>
                                        <col span={1} style={{width: "50%"}}></col>
                                        <col span={1} style={{width: "50%"}}></col>
                                    </colgroup>
                                    <tbody>
                                    <tr><td>Model</td><td>{sunmiDeviceInfo?.printer?.model}</td></tr>
                                    <tr><td>Printer SN</td><td>{sunmiDeviceInfo?.printer?.sn}</td></tr>
                                    <tr><td>Printer Version</td><td>{sunmiDeviceInfo?.printer?.version}</td></tr>
                                    <tr><td>Printer Type</td><td>{`${sunmiDeviceInfo?.printer?.prt_mode} (${sunmiDeviceInfo?.printer?.prt_paper})`}</td></tr>
                                    <tr><td>Printed Length</td><td>{`${(Number(sunmiDeviceInfo?.printer?.prtlength || 0) / 1000).toFixed(2)} μέτρα`}</td></tr>
                                    </tbody>
                                </table>
                                <Button style={{padding: "7px", marginTop: "10px"}} variant="primary" disabled={simInfoLoader || isEmpty(sunmiDeviceInfo?.net?.sim)} onClick={() => getSimInfo()}>
                                    <SiVodafone size={20} style={{marginRight: "5px"}} />
                                    {" Πληροφορίες Κάρτας SIM "}
                                    {simInfoLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    <SiVodafone size={20} style={{marginLeft: "5px"}} />
                                </Button>
                            </div>
                        </div>
                        <hr />
                        <div className={"d-flex justify-content-between"}>
                            <div className={"mr-2"} style={{flex: 1}}>
                                <p className="text-muted mb-2"><i>Ενέργειες Συσκευής:</i></p>
                                <Row className={"mb-3"}>
                                    <Col md={6}>
                                        <Button style={{padding: "10px"}} variant="primary" disabled={sunmiLoader || !onlineStatus} onClick={() => sunmiDeviceAction("powerOff")}>
                                            <RiShutDownLine size={18} />
                                            {" Τερματισμός Συσκευής "}
                                            {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                        </Button>
                                    </Col>
                                    <Col md={6}>
                                        <Button style={{padding: "10px"}} variant="primary" disabled={sunmiLoader || !onlineStatus} onClick={() => sunmiDeviceAction("reboot")}>
                                            <VscDebugRestart size={18} />
                                            {" Επανεκκίνηση Συσκευής "}
                                            {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                        </Button>
                                    </Col>
                                </Row>
                                <Row className={"mb-2"}>
                                    <Col md={6}>
                                        <Button style={{padding: "10px"}} variant="primary" disabled={sunmiLoader || !onlineStatus} onClick={() => sunmiDeviceAction("lock")}>
                                            <MdOutlineLock size={18} />
                                            {" Κλείδωμα Συσκευής "}
                                            {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                        </Button>
                                    </Col>
                                    <Col md={6}>
                                        <Button style={{padding: "10px"}} variant="primary" disabled={sunmiLoader || !onlineStatus} onClick={() => sunmiDeviceAction("remoteControl")}>
                                            <VscRemoteExplorer size={18} />
                                            {" Απομακρυσμένος Έλεγχος "}
                                            {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <div className={"ml-2"} style={{flex: 1}}>
                                <p className="text-muted mb-2"><i>Αρχείο Καταγραφής Ενεργειών:</i></p>
                                <div style={{ maxHeight: '17vh', overflowY: 'auto', borderBottom: '1px black solid' }}>
                                    <table style={{position: 'sticky', top: "0px", width: "100%"}} className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "30%"}}></col>
                                            <col span={1} style={{width: "40%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Ημερομηνία</th>
                                            <th>Ενέργεια</th>
                                            <th>Χρήστης</th>
                                        </tr>
                                        </thead>
                                    </table>
                                    <table className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "30%"}}></col>
                                            <col span={1} style={{width: "40%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                        </colgroup>
                                        <tbody>
                                        {(selectedPos?.deviceLogs || [])
                                            .slice()
                                            .sort((a, b) => new Date(b.date) - new Date(a.date))
                                            .map((row, idx) => (
                                                <tr key={`fsHistory-${idx}`}>
                                                    <td>{moment(row.date).format("DD/MM/YYYY HH:mm:ss")}</td>
                                                    <td>{row.description}</td>
                                                    <td>{row.user}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setSunmiDeviceInfo(null)}>
                        Κλείσιμο
                    </Button>
                </Modal.Footer>
            </Modal>
            <PrimerPosSimInfoModal simInfo={simInfo} setSimInfo={setSimInfo} />
        </React.Fragment>
    )
}

export default PrimerPosSunmiInfoModal;